import { render, staticRenderFns } from "./Programme.vue?vue&type=template&id=b4282a8c&"
import script from "./Programme.vue?vue&type=script&lang=js&"
export * from "./Programme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports